module.exports = __webpack_public_path__ + "static/img/curdis.e605f244.jpg";